export const styles = {
  messageTimeBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    p: '32px 0 16px',
    border: '1px solid gray',
    borderRadius: 20,
    padding: '4px',
    marginTop: 16,
  },
};
